import request from '../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../types/enums/request-enums';

const GetStudioPrompts = (params?: {
    name?: string;
    promptType?: number;
    category?: string;
    isActive?: boolean;
    pageNumber?: number;
    pageSize?: number;
}): Promise<any> => {
    const queryParams = new URLSearchParams();
    
    if (params?.name) queryParams.append('name', params.name);
    if (params?.promptType !== undefined) queryParams.append('promptType', params.promptType.toString());
    if (params?.category) queryParams.append('category', params.category);
    if (params?.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());
    if (params?.pageNumber) queryParams.append('pageNumber', params.pageNumber.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());

    return request({
        url: `${ApiURL.Query.StudioQueryURLs.StudioPromptQueryURL.GetStudioPrompts}?${queryParams.toString()}`,
        method: RequestType.GET,
    });
};

const GetStudioPromptById = (id: number): Promise<any> =>
    request({
        url: `${ApiURL.Query.StudioQueryURLs.StudioPromptQueryURL.GetStudioPromptById}/${id}`,
        method: RequestType.GET,
    });

export const StudioPromptQuery = {
    GetStudioPrompts,
    GetStudioPromptById,
};

export default StudioPromptQuery;

